var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangeAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.92086C0.258993 3.4964 0.94964 2.28777 2.07194 1.38129C3.19424 0.47482 4.48921 0 5.95683 0C6.90648 0 7.76978 0.215827 8.58993 0.647482C9.41007 1.07914 10.1007 1.64029 10.705 2.41727V0H12V4.92086H7.07914V3.6259H9.97122C9.4964 2.93525 8.93525 2.3741 8.2446 1.94245C7.55396 1.51079 6.77698 1.29496 5.95683 1.29496C4.83453 1.29496 3.84173 1.64029 2.97842 2.28777C2.11511 2.93525 1.55396 3.84173 1.29496 4.92086H0ZM12 7.07914C11.741 8.5036 11.0504 9.71223 9.92806 10.6187C8.80576 11.5252 7.51079 12 6.04317 12C5.09353 12 4.23022 11.7842 3.41007 11.3525C2.58993 10.9209 1.89928 10.3165 1.29496 9.58273V12H0V7.07914H4.92086V8.3741H2.02878C2.5036 9.06475 3.06475 9.6259 3.7554 10.0576C4.44604 10.4892 5.22302 10.705 6.04317 10.705C7.16547 10.705 8.15827 10.3597 9.02158 9.71223C9.88489 9.02158 10.446 8.15827 10.705 7.07914H12Z",
    fill: "#4B2B5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeAudio);
export default __webpack_public_path__ + "static/media/changeAudio.7e42171a56216e13426d40b42be62cbf.svg";
export { ForwardRef as ReactComponent };